export default __webpack_public_path__ + "static/Karachi-043c10c6f4294f7166db21123e256320.svg";